// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kGHO","rootMobile":"styles_rootMobile___w0oI"};